import React from 'react'
import { Jumbotron } from 'react-bootstrap'

const BannerBrandImageSection = (props) => {
  return (
    <Jumbotron fluid className="mb-0 banner-home-lower">
      <div
        className="banner-bg banner-brand-bg"
        style={{
          backgroundImage: props.src ? `url(${props.src})` : '',
        }}
        id={props.id}
        tabIndex={-1}
      >
        {props.children}
      </div>
    </Jumbotron>
  )
}

export default BannerBrandImageSection
